// extracted by mini-css-extract-plugin
module.exports = {"box":"Stats_box__3Ee3_","text":"Stats_text__12ZqN","num":"Stats_num__1SWaT"};